import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import useImportacionesSubpartida from "../../../hooks/administrador/adheridos/useImportacionesSubpartida";
import '../../../styles/administrador.css';

const ImportacionesSubpartida = ({ year, mes, token, idAdministrador }) => {
  const chartRef = useRef(null);
  const { data, loading, error } = useImportacionesSubpartida(year, mes, token, idAdministrador);

  useEffect(() => {
    if (loading || !chartRef.current) return;
  
    if (error || !Array.isArray(data) || data.length === 0) {
      if (chartRef.current) {
        chartRef.current.innerHTML = "<p style='text-align: center; color: black;'>No hay datos disponibles</p>";
      }
      return;
    }
  
    const chartDom = chartRef.current;
    let myChart = echarts.getInstanceByDom(chartDom);
    if (myChart) myChart.dispose();
    myChart = echarts.init(chartDom);
  
    const colorPalette = ['#d1dc5a', '#6ac5cb', '#45444e', '#a3b85b', '#3a6b74', '#7d8a2e', '#3d9199', '#62615e', '#879b4a', '#2b5258'];
  
    const formattedData = data.map((item, index) => {
      const name = item.subpartida || 'Sin nombre';
      const value = parseFloat(item.cantidad_importada) || 0;
  
      return {
        name: name,
        value: value,
        itemStyle: {
          color: colorPalette[index % colorPalette.length]
        }
      };
    });
  
    const totalImportaciones = formattedData.reduce((sum, item) => sum + item.value, 0);
  
    const option = {
      title: {
        text: 'Importaciones por subpartida',
        subtext: `TOTAL DE IMPORTACIONES: ${totalImportaciones.toLocaleString()}`,
        left: 'center',
        top: '10',
        textStyle: {
          fontSize: 18,
          fontWeight: 'bold'
        },
        subtextStyle: {
          fontSize: 12,
          fontWeight: 'bold'
        }
      },
      tooltip: {
        show: false  
      },
      legend: {
        show: true,
        type: 'scroll',  
        orient: 'horizontal',  
        left: 'center',  
        bottom: '10',  
        textStyle: {
          fontSize: 12,
          color: '#333'
        },
        formatter: function (name) {
          const item = formattedData.find((item) => item.name === name);
          const cantidad = item ? item.value.toLocaleString('es-ES') : 0;
          const shortenedName =
            name.length > 13 ? `${name.slice(0, 13)}...` : name;  
          return `${shortenedName}\n${cantidad} [U]`;  
        },
        pageIconColor: '#333',  
        pageIconSize: 23,  
        pageTextStyle: {
          fontSize: 12,
          color: '#333'
        }
      },
      graphic: {
        type: 'group',
        left: 'center',
        top: 'center',
        children: [
          {
            type: 'text',
            id: 'centerText',
            left: 'center',
            top: 'center',
            style: {
              text: `Total\n${totalImportaciones.toLocaleString()}`,  
              textAlign: 'center',
              fontSize: 16,
              fontWeight: 'bold',
              lineHeight: 20
            }
          }
        ]
      },
      series: [
        {
          name: 'Importaciones',
          type: 'pie',
          radius: ['40%', '70%'],  
          center: ['50%', '50%'],
          label: {
            show: false  
          },
          data: formattedData,
          itemStyle: {
            borderColor: '#fff',  
            borderWidth: 2  
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          labelLine: {
            show: false  
          }
        }
      ]
    };
  
    myChart.setOption(option);
  
     
    myChart.on('click', function (params) {
      if (params.seriesType === 'pie') {
        myChart.setOption({
          graphic: {
            children: [
              {
                type: 'text',
                id: 'centerText',
                left: 'center',
                top: 'center',
                style: {
                  text: `${params.name}\n${params.value.toLocaleString()} [U]`,  
                  textAlign: 'center',
                  fontSize: 16,
                  fontWeight: 'bold',
                  lineHeight: 20
                }
              }
            ]
          }
        });
      }
    });
  
    const updateChart = () => {
      myChart.resize();
    };
  
    window.addEventListener('resize', updateChart);
  
    return () => {
      window.removeEventListener('resize', updateChart);
      if (myChart && !myChart.isDisposed()) {
        myChart.dispose();
      }
    };
  }, [data, loading, error]);

  if (loading) {
    return <div className="grafica loading">Cargando datos de importaciones...</div>;
  }

  return <div className="grafica" ref={chartRef}></div>;
};

export default ImportacionesSubpartida;